export default "__VITE_ASSET__DOpYMrgU__"